import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f92526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AInput p-input-filled p-float-label field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}

import InputText from "primevue/inputtext"
  import InputMask from "primevue/inputmask"
  import { computed, onBeforeMount, shallowRef, Ref, withDefaults } from "vue"

  type InputTipo = typeof InputText | typeof InputMask

  interface InputProps {
    desativado?: boolean
    label?: string
    mensagemDeErro?: string | Ref<string>
    modelValue: string | Ref<string> | any
    mask?: string
    nome: string
    tipoEntrada?: string
    obrigatorio?: boolean
    retirarCaractereEspecial?: boolean
    dataTestid?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MInput',
  props: {
    desativado: { type: Boolean },
    label: null,
    mensagemDeErro: null,
    modelValue: null,
    mask: null,
    nome: null,
    tipoEntrada: null,
    obrigatorio: { type: Boolean },
    retirarCaractereEspecial: { type: Boolean },
    dataTestid: { default: "MInput" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: "update:modelValue", modelValue: string | Ref<string>): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { desativado?: boolean, label?: string, mensagemDeErro?: string | Ref<string>, modelValue: string | Ref<string> | any, mask?: string, nome: string, tipoEntrada?: string, obrigatorio?: boolean, retirarCaractereEspecial?: boolean, dataTestid: string }

  

  

  const tipoInput = shallowRef<InputTipo>(InputText)
  const emitirModel = computed({
    get(): string | Ref<string> {
      return props.modelValue
    },
    set(valorDigitado: string | Ref<string>) {
      if (props.retirarCaractereEspecial) {
        const regex = /[^a-zA-Z0-9À-ÿ\s-'´`]/g
        valorDigitado = valorDigitado.replace(regex, "")
      }
      emits("update:modelValue", valorDigitado)
    },
  })
  const determinarInput = (temMascara: boolean): InputTipo => {
    if (temMascara) {
      return InputMask
    }
    return InputText
  }
  onBeforeMount(() => {
    tipoInput.value = determinarInput(!!props.mask)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tipoInput)), {
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
      id: __props.nome,
      class: _normalizeClass({ 'p-invalid': __props.mensagemDeErro }),
      "data-testid": __props.dataTestid,
      disabled: __props.desativado,
      mask: __props.mask,
      type: __props.tipoEntrada,
      "aria-describedby": "input-help"
    }, null, 8, ["modelValue", "id", "class", "data-testid", "disabled", "mask", "type"])),
    _createElementVNode("label", { for: __props.nome }, [
      _createTextVNode(_toDisplayString(__props.label), 1),
      (__props.obrigatorio)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _withDirectives(_createElementVNode("small", {
      id: "input-help",
      class: "p-error",
      "data-testid": "input-error"
    }, _toDisplayString(__props.mensagemDeErro), 513), [
      [_vShow, __props.mensagemDeErro]
    ])
  ]))
}
}

})